"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRemovalRequest = exports.DataRemovalStatusTypes = void 0;
var DataRemovalStatusTypes;
(function (DataRemovalStatusTypes) {
    DataRemovalStatusTypes["Pending"] = "Pending";
    DataRemovalStatusTypes["Done"] = "Done";
})(DataRemovalStatusTypes = exports.DataRemovalStatusTypes || (exports.DataRemovalStatusTypes = {}));
var DataRemovalRequest = /** @class */ (function () {
    function DataRemovalRequest(requestedBy, requestedFor, notifyWhenCompleted) {
        this.RequestedBy = requestedBy;
        this.RequestedFor = requestedFor;
        this.NotifyWhenCompleted = notifyWhenCompleted;
    }
    return DataRemovalRequest;
}());
exports.DataRemovalRequest = DataRemovalRequest;
//# sourceMappingURL=DataRemovals.js.map